
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.592.138a.93.93 0 01.833 0l9.064 4.598a.757.757 0 01.433.668v9.197a.757.757 0 01-.433.668l-9.064 4.599a.93.93 0 01-.833 0L.528 15.269a.757.757 0 01-.433-.668V5.404c0-.277.166-.532.433-.668L9.592.138zM1.795 5.853v8.3l8.214 4.167 8.214-4.167v-8.3l-8.214-4.168-8.214 4.168zm18.018-.825c.23.368.085.836-.324 1.043l-9.064 4.599c-.409.207-.927.076-1.157-.293-.23-.368-.085-.836.324-1.043l9.064-4.599c.409-.207.927-.076 1.157.292zm-9.804 4.208c.469 0 .85.344.85.767V19.2c0 .423-.381.766-.85.766-.47 0-.85-.343-.85-.766v-9.197c0-.423.38-.767.85-.767zM.204 5.027c.23-.368.748-.5 1.157-.292l9.064 4.599c.409.207.554.675.324 1.043-.23.37-.749.5-1.158.293L.53 6.07c-.41-.207-.554-.675-.324-1.043zM15.28 2.73c.23.369.085.836-.324 1.043l-9.064 4.6c-.409.207-.927.076-1.157-.293-.23-.37-.085-.836.324-1.044l9.064-4.598c.41-.208.927-.077 1.157.292z","fill":"#305BF2"}})])
          )
        }
      }
    